__turbopack_context__.v({
  "chart": "b9OiIa_chart",
  "container": "b9OiIa_container",
});
